"use client";

import React from 'react';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import FeatureRow from '@/components/FeatureRow';
import ShopSection from '@/components/ShopSection';
import TestimonialsSection from '@/components/TestimonialsSection';
import GearSection from '@/components/GearSection';
import SlideshowSection from '@/components/SlideshowSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';

export default function HomePage() {
  return (
    <div className="page-container">
      {/* Header */}
      <Header />

      <main id="MainContent">
        {/* Hero Section */}
        <HeroSection />

        {/* Eastpoint Roastery Feature Row */}
        <FeatureRow
          id="locations"
          imageSrc="https://coffeebythebay.com/cdn/shop/files/19426E88-4889-4B20-8DA7-73E41A2407F4_2_540x.jpg?v=1649687538"
          imageAlt="Eastpoint Roastery location exterior with outdoor seating area"
          imageAspectRatio={1.347}
          title="Eastpoint Roastery"
        >
          <p>
            Our Eastpoint location offers indoor and outdoor seating, as well as free wifi.
            Enjoy fresh baked goods like danish, muffins, and turnovers! We roast on-site
            daily so enjoy the aroma of freshly roasted coffee over breakfast!
          </p>
          <p>&nbsp;</p>
          <p>327 Highway 98 Eastpoint, Florida 32328</p>
          <p>Monday-Friday: 7am-12:30pm</p>
          <p>Saturday: 8:00am-2:00pm</p>
        </FeatureRow>

        {/* SGI Location Feature Row */}
        <FeatureRow
          id="sgi"
          imageSrc="https://coffeebythebay.com/cdn/shop/files/IMG_4552_540x.jpg?v=1774019314"
          imageAlt="SGI Location at BJ's Pizza on St George Island with coffee shop signage"
          imageAspectRatio={0.75}
          title="SGI Location"
        >
          <p>We are conveniently located inside BJ&apos;s Pizza!</p>
          <p>Stop by and enjoy and our locally roasted coffee, cold brew, lattes, and pastries!</p>
          <p>&nbsp;</p>
          <p>105 W Gulf Beach Dr, St George Island, FL 32328</p>
          <p>Tuesday-Friday 7:30am-12:30pm</p>
          <p>Saturday 8am-12:30pm</p>
        </FeatureRow>

        {/* Shop Online Section */}
        <ShopSection />

        {/* About Section */}
        <FeatureRow
          id="about"
          imageSrc="https://coffeebythebay.com/cdn/shop/files/4FB5DD9B-BD58-430A-8A88-A66BBEC682BD_200x200.JPG?v=1615924141"
          imageAlt="Bayside Coffee Co. roasting facility with coffee roaster machine and bags of coffee beans"
          imageAspectRatio={1}
          title="Bayside Coffee Co."
        >
          <p>
            We&apos;re a small-batch coffee roaster located in Eastpoint, Florida. We offer
            fresh-brewed coffee by the cup, lattes, cappuccinos and cold brew! Stop in and
            let the good times begin.
          </p>
        </FeatureRow>

        {/* Testimonials Section */}
        <TestimonialsSection />

        {/* Full-width photo hero between sections */}
        <section className="mid-hero">
          <div
            className="mid-hero__bg"
            style={{
              backgroundImage: `url('https://coffeebythebay.com/cdn/shop/files/IMG_0535_1080x.JPG?v=1615924141')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
        </section>

        {/* Gear Section */}
        <GearSection />

        {/* Slideshow Section */}
        <SlideshowSection />

        {/* Contact Section */}
        <ContactSection />
      </main>

      {/* Footer */}
      <Footer />

      <style jsx>{`
        .page-container {
          font-family: 'Work Sans', sans-serif;
          color: #3d4246;
          background: #fff;
        }
        .mid-hero {
          width: 100%;
          position: relative;
        }
        .mid-hero__bg {
          width: 100%;
          height: 400px;
        }
        @media (max-width: 749px) {
          .mid-hero__bg {
            height: 220px;
          }
        }
      `}</style>
    </div>
  );
}
